import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getResidueList,
	addNewResidue,
	updateResidue,
	deleteResidue,
	getResidue,
} from '../residue/thunk';

export const initialState = {
	itemResidueList: [],
	itemResidueDetail: null,
	isResidueLoading: false,
	isResidueSuccess: false,

	residueList: [],
	residueListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ResidueSlice = createSlice({
	name: 'Residues',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getResidue.fulfilled, (state, action) => {
			state.isResidueLoading = false;
			state.isResidueSuccess = true;
			state.itemResidueDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getResidue.pending, state => {
			state.isResidueLoading = true;
			state.isResidueSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getResidue.rejected, (state, action) => {
			state.isResidueLoading = false;
			state.isResidueSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getResidueList.pending, state => {
			state.isResidueSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getResidueList.fulfilled, (state, action) => {
			state.itemResidueList = action.payload;
			state.residueList = action.payload;
			state.isLoadingList = false;
			state.isResidueSuccess = true;

			let residueListSelect = [];
			action.payload.map(item =>
				residueListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.residueListSelect = residueListSelect;
		});
		builder.addCase(getResidueList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isResidueSuccess = true;
		});
		builder.addCase(addNewResidue.fulfilled, (state, action) => {
			state.itemResidueList.push(action.payload);
			state.residueList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewResidue.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewResidue.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateResidue.fulfilled, (state, action) => {
			state.itemResidueList = state.itemResidueList.map(residue =>
				residue.residuename === action.payload.old_residue
					? { ...residue, ...action.payload.updated_residue }
					: residue
			);
			state.residueList = state.residueList.map(residue =>
				residue._id.toString() === action.payload._id.toString()
					? { ...residue, ...action.payload }
					: residue
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateResidue.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateResidue.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteResidue.fulfilled, (state, action) => {
			state.itemResidueList = current(state.itemResidueList).filter(
				item => item._id !== action.payload._id
			);
			state.residueList = current(state.residueList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteResidue.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteResidue.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = ResidueSlice.actions;

export default ResidueSlice.reducer;